Vue.component('ack-application-workflow-title', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-application-workflow-title',
	mounted() {},
	props: {
		applicationInfo: {
			// :product-info
			type: Object,
			required: true,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
		shopProductInfo: {
			type: Object,
			required: false,
		},
		dentalApplicationId: {
			type: String,
			required: true,
		},
	},
	computed: {
		//...Vuex.mapGetters('shop', ['productList']),
		...Vuex.mapGetters('shop', ['currentCurrency', 'currentCurrencySymbol', 'currentCountryCode']),
		...Vuex.mapGetters('localization', ['isIreland', 'isTW']),
		isUSorCA() {
			return (
				this.currentCountryCode.toUpperCase() == 'US' ||
				this.currentCountryCode.toUpperCase() == 'CA'
			);
		},

		productIsNotAvailableInRegion() {
			let notAvailable = false;
			if (
				this.currentCountryCode.toUpperCase() == 'US' ||
				this.currentCountryCode.toUpperCase() == 'CA'
			) {
				notAvailable = true;
			}
			return notAvailable;
		},
	},
	data() {
		return {};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('shop', ['addSelectedItem', 'removeSelectedItem']),
	},
	beforeDestroy() {},
	watch: {
		isMobile: {
			handler() {},
			deep: false,
		},
	},
});
